import { render, staticRenderFns } from "./ScaniaDrivingAssistanceMenu.vue?vue&type=template&id=b334e900&"
import script from "./ScaniaDrivingAssistanceMenu.vue?vue&type=script&lang=js&"
export * from "./ScaniaDrivingAssistanceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports